import React, { Component, PropTypes } from 'react';
import ClassNames from 'classnames';
import { FormattedDate } from 'react-intl';
import HammerWrapper from 'components/HammerWrapper';
import { GridContainer, GridRow, GridCell } from 'components/Grid/Grid';
import { FlatButton, RaisedButton } from 'material-ui';
import VideoPreview from 'components/Widgets/VideoPreview';
import TextField from 'components/Widgets/TextField';
import Constants from 'Constants';

let types = Constants.fileTypeIcons;

export default class FileList extends Component {
  state = {
    selected: {}
  };

  static contextTypes = {
    getIntlMessage: PropTypes.func
  };

  static propTypes = {
    list: PropTypes.array,
    sort: PropTypes.object,
    filter: PropTypes.object,
    removeFilter: PropTypes.func,
    onSelect: PropTypes.func,
    onTap: PropTypes.func,
    searchHint: PropTypes.string,
    style: PropTypes.oneOf(['list', 'thumb'])
  };

  static defaultProps = {
    style: 'list',
    searchHint: 'Search'
  };

  onSearchTextChange(e) {
    let value = e.target.value;
    if (this._debounce) {
      clearTimeout(this._debounce);
    }
    this._debounce = setTimeout(() => {
      this.setState({ searchText: value });
    }, 300);
  }

  selectFile(id) {
    let selected = this.state.selected;
    selected[id] = !selected[id];
    if (!selected[id]) {
      delete selected[id];
    }
    this.setState({ selected });
    if (this.props.onSelect) {
      this.props.onSelect(this.state.selected);
    }
  }

  removeFilter() {
    if (this.props.removeFilter) {
      this.props.removeFilter();
    }
  }

  getSelectedFiles() {
    return this.state.selected;
  }

  onTap(fileId) {
    if (this.props.onTap) {
      this.props.onTap(fileId);
    }
  }

  render() {
    let hasFilter, searchBar;
    searchBar = (
      <GridCell size={12}>
        <div className="search-bar">
          <TextField
            icon={'md md-search'}
            hintText={this.context.getIntlMessage(this.props.searchHint)}
            ref="searchField"
            onChange={this.onSearchTextChange.bind(this)}
          />
        </div>
      </GridCell>
    );
    if (this.props.list.length > 0) {
      let list = this.props.list;
      if (this.props.filter.type) {
        hasFilter = (
          <GridContainer fluid={true} className="filtered-warning">
            <GridCell size={6}>
              {this.context.getIntlMessage('resultsFiltered')}
            </GridCell>
            <GridCell size={6} className="right">
              <FlatButton
                primary={true}
                label="Remove"
                onTouchTap={this.removeFilter.bind(this)}
              />
            </GridCell>
          </GridContainer>
        );

        let fileType = this.props.filter.type;
        list = list.filter(file => {
          return file.type.indexOf(fileType) === 0;
        });
      }
      if (this.state.searchText && this.state.searchText !== '') {
        let searchText = this.state.searchText.toUpperCase();
        list = list.filter(file => {
          return file.name.toUpperCase().indexOf(searchText) > -1;
        });
      }
      if (this.props.sort.property) {
        let sortProperty = this.props.sort.property;
        list.sort((a, b) => {
          if (typeof a[sortProperty] === 'string') {
            a = a[sortProperty].toUpperCase();
            b = b[sortProperty].toUpperCase();
            if (a < b) return -1;
            if (a > b) return 1;
            return 0;
          } else {
            a = a[sortProperty];
            b = b[sortProperty];
            if (a < b) return -1;
            if (al > b) return 1;
            return 0;
          }
        });
      }
      let files = list.map((file, index) => {
        let coverStyle, thumb;
        coverStyle = {
          backgroundImage: 'none'
        };

        if (this.props.style === 'list') {
          let fileType = file.type.substring(0, file.type.indexOf('/'));
          if (fileType === 'image') {
            coverStyle = {
              backgroundImage: 'url(' + file.url + ')'
              // backgroundImage: 'url(http://lorempixel.com/144/144/technics)'
            };
            thumb = <div className="thumb" style={coverStyle} />;
          } else if (fileType === 'video') {
            let extension = file.url.split('.').pop();
            thumb = (
              <VideoPreview
                style={{ display: 'inline-block' }}
                sources={[{ url: file.url, type: extension }]}
              />
            );
          } else if (types[fileType]) {
            thumb = (
              <div className="thumb" style={coverStyle}>
                <i className={'zmdi zmdi-hc-2x zmdi-' + types[fileType]} />
              </div>
            );
          } else {
            thumb = (
              <div className="thumb" style={coverStyle}>
                <i className={'zmdi zmdi-hc-2x zmdi-file'} />
              </div>
            );
          }
          let date =
            (file.created && (
              <FormattedDate value={new Date(file.created)} />
            )) ||
            '';
          return (
            <div
              key={index}
              className={ClassNames('file', {
                selected: this.state.selected[file.id]
              })}
            >
              <div
                className="checkbox"
                onTouchTap={this.selectFile.bind(this, file.id)}
              >
                <i className="zmdi zmdi-hc-2x zmdi-check" />
              </div>
              {thumb}
              <div className="description">
                <h3>{file.name}</h3>
                <h3 className="date">{date}</h3>
              </div>
            </div>
          );
        } else {
          let color = file.metadata;
          let fileType = file.type.substring(0, file.type.indexOf('/'));
          if (fileType === 'image') {
            coverStyle = {
              backgroundImage: 'url(' + file.url + ')'
              // backgroundImage: 'url(http://lorempixel.com/144/144/technics)'
            };
            thumb = <div className="thumb" style={coverStyle} />;
          } else if (fileType === 'video') {
            let extension = file.url.split('.').pop();
            thumb = (
              <VideoPreview
                style={{ display: 'inline-block' }}
                sources={[{ url: file.url, type: extension }]}
              />
            );
          } else if (types[fileType]) {
            thumb = (
              <div className="thumb" style={coverStyle}>
                <i className={'zmdi zmdi-hc-2x zmdi-' + types[fileType]} />
                <br />
                {file.name}
              </div>
            );
          } else {
            thumb = (
              <div className="thumb" style={coverStyle}>
                <i className={'zmdi zmdi-hc-2x zmdi-file'} />
                <br />
                {file.name}
              </div>
            );
          }

          return (
            <HammerWrapper
              component="div"
              key={file.id}
              onTap={this.onTap.bind(this, file.id)}
              onPress={this.selectFile.bind(this, file.id)}
              className={ClassNames('thumb-holder', {
                selected: this.state.selected[file.id]
              })}
            >
              {thumb}
            </HammerWrapper>
          );
        }
      });
      return (
        <div className={ClassNames('file-list', this.props.style)}>
          {searchBar}
          {hasFilter}
          {files}
        </div>
      );
    } else {
      return <div />;
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/components/Widgets/FileList.js